import { createContext } from 'react';

export default createContext({
  accountInfo: undefined,
  logout: undefined,
  mobileMenuOpen: undefined,
  permissions: undefined,
  setMobileMenuOpen: undefined
});
